import React from 'react';
import cn from 'bem-cn';

import { CourseCard } from '../../components/CourseCard/CourseCard';
import { CourseCardSkeleton } from '../../components/CourseCardSkeleton';
import { BigTitleWithText } from '../../components/BigTitleWithText/BigTitleWithText';
import { useGetCoursesQuery } from '../../store/services';

import './CourseListPage.scss';

const b = cn('course-list-page');

export const CourseListPage: React.FC = () => {
    const { data: courses, isLoading, error } = useGetCoursesQuery();

    if (isLoading) {
        return (
            <div className={b()}>
                <BigTitleWithText
                    title="Давайте учиться"
                    text="Обучающие курсы про ИИ для новичков и уже не новичков"
                />
                <div className={b('course-list')}>
                    {Array.from({ length: 4 }, (_, index) => (
                        <CourseCardSkeleton key={index} />
                    ))}
                </div>
            </div>
        );
    }

    if (error) {
        return (
            <div className={b()}>
                <BigTitleWithText
                    title="Давайте учиться"
                    text="Обучающие курсы про ИИ для новичков и уже не новичков"
                />
                <div className={b('course-list')}>
                    <div>Курсы не найдены</div>
                </div>
            </div>
        );
    }

    return (
        <div className={b()}>
            <BigTitleWithText title="Давайте учиться" text="Обучающие курсы про ИИ для новичков и уже не новичков" />
            <div className={b('course-list')}>
                {courses?.map(course => <CourseCard key={course.id} course={course} />)}
            </div>
        </div>
    );
};
